import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import {
    MainContainer,
    Title,
    RadioRowDiv,
    ShippingContainerSize,
    ShippingContainer,
    AdvanceSelectButton,
    AutoCompleteContainer,
    AlertMsg,
    ShipToCorousalDiv,
    AlertMsgShipToAccount,
    CarousalContainer,
    DetailsMainContainer,
    MainContainerSecond,
    MainContainerThird,
    OptionContainer,
    ImageContainer,
    SurgeryDateViewAndNumberContainer,
    FlexDiv,
} from './ShipAddressModal.styled';
import {
    MainContainerItems,
    SurgeryDateView,
} from 'src/pages/scheduleSurgery/components/details/Details.styled.jsx';
import { getDropdownValues } from 'src/pages/scheduleSurgery/redux/actions';
import { OptionalLoadMoreView } from 'src/common/components/createTemplate/CreateTemplate.styled.jsx';
import {
    getDropdownOptionsRequest,
    getShipToAddress,
    getShippingMethods,
    clearInsideShippingAddress,
    setUsageSurgeryOutsideAction,
    clearOutsideShippingAddress,
    setSelectedOutsideAccount,
    setShippingDetails,
    storeRequestDeliveryDate,
    getTransferRecipientMethods,
    clearTransferRecipients,
    clearOutsideShippingAddressWhenBillToCleared,
    setReplenishmentSurgeryNumber,
    clearValidateReplenData,
    clearSingleDropDownList,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import ReportAutoComplete from 'src/pages/reportUsage/common/autoComplete/ReportAutoComplete';
import InputField from 'src/pages/reportUsage/common/inputField/InputField';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import Select from 'src/common/refactoredComponents/select/Select';
import { sizes } from 'src/styles/Media.styled';
import InputBox from 'src/common/refactoredComponents/input/Input';
import Carousel from 'src/common/refactoredComponents/carousel/index';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import AccountPhysicianTemplate from 'src/pages/scheduleSurgery/components/details/AccountPhysicianTemplate';
import ShippingAddressCard from 'src/pages/scheduleSurgery/components/shipping/ShippingAddressCard';
import Calendar from 'src/assets/images/CalendarTodayBlue.svg';
import DatePicker from 'src/common/components/datePicker/DatePicker';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { SurgeryDateViewAndNumber } from 'src/pages/scheduleSurgery/components/details/Details.styled';
import { isIpad, debounce, logErrorToConsole } from 'src/utils/util';
import { CommonEmptyBox } from 'src/styles/CommonStyles.styled';
import { OutsideTerritory } from 'src/pages/reportUsage/replen/components/replenConstant';
import { RequestDeliveryDateView } from 'src/pages/consignmentAdd/components/account/AccountContainer.styled';
import {
    getDisabledDatesBasedOnJapanTime,
    getJapanCurrentDateTime,
    getMinimumDatesBasedOnJapanTime,
    getTomorrowDate,
    getRddDate,
    getNumberOfDaysBetweenTwoDates,
} from 'src/utils/dateUtils';
import moment from 'moment';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import {
    VISIBLE,
    US_COUNTRY_CODE,
    MANDATORY,
} from 'src/constants/appConstants';
import ShipToTemplate from 'src/pages/reportUsage/procedure/components/shipToTemplate/shipToTemplate';
import { DropdownOption } from 'src/constants/templateConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ShipAddressModalOutside = ({
    onClose,
    advanceSearch,
    selectedList,
    gridData,
    setGridData,
    territory,
    advanceSearchValue,
    setSelectedList,
    requestedDeliveryDateVisibility,
    countryISOCode,
    requestedDeliveryDateMandatory,
    handleRequestDeliveryDate,
    requestDeliveryDate,
    isRequestDeliveryMandate,
    isSurgeryDateMandate,
    usageReplenishmentSurgeryDateMandatoryRule,
    accountId,
    getDisable,
    surgeryNumberUsageReplenishmentVisibility,
    surgeryNumberUsageReplenishmentMandatory,
    numberOfSurgery,
    setNumberOfSurgery,
    replenishmentSurgeryNumber,
    usageReplenishmentSurgeryDateVisibility,
    setAccountData,
    accountData,
    isSurgeryNumberMandate,
    applyShippingAddress = () => {},
    AccountId,
    setUsageTransferRecipient = () => {},
    usageTransferRecipient,
    setShippingMethodValue = () => {},
    shippingMethodValue,
    setSelectedShipTo = () => {},
    handleSurgeryDate,
    selectedShipTo,
    nextDay,
    setShipToClick = () => {},
    applyClickOutside,
    setApplyClickOutside = () => {},
    shipToClick,
    setCareOfValue = () => {},
    careOfValue,
    setSurgeryDate,
    surgeryDate,
    setAttnValue,
    attnValue,
    accountDetails,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const shipToRef = useRef();
    const transferRecipientRef = useRef();
    const billToRef = useRef();
    const accountRef = useRef();
    
    const {
        accounts,
        surgeryDetails,
        billToDetails,
        physicianDetails,
        requestedDeliveryDateCutOffTime,
        enableRequestedDeliveryDateForWeekEnd,
        currentDateDelivery,
        allDayRequestedDeliveryDate,
    } = useSelector((state) => ({
        surgeryDetails: state.reportShipToAddressReducer.outsideSurgeryDetails,
        districts: state?.detailsDropdownsReducer?.districts?.items,
        territories: state?.detailsDropdownsReducer?.territories?.items,
        accounts: state?.detailsDropdownsReducer?.accountLookup?.items,
        sapID: state?.loginReducer?.hybrisUserDetails?.sapID,
        requestedDeliveryDateCutOffTime:
            state?.loginReducer?.requestedDeliveryDateCutOffTime,
        billToDetails: state?.detailsDropdownsReducer?.billToDetails?.items,
        physicianDetails:
            state?.reportUsageRootReducer?.dropdownData?.physicians
                ?.physicianList,
        enableRequestedDeliveryDateForWeekEnd:
            state.loginReducer.enableRequestedDeliveryDateForWeekEnd,
        currentDateDelivery: state.loginReducer.currentDateDelivery,
        allDayRequestedDeliveryDate:
            state.loginReducer.allDayRequestedDeliveryDate,
    }));
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const {
        nonTissueAddress,
        tissueAddress,
        selectedAccount,
        shipToAddressLoading,
    } = useSelector((state) => ({
        nonTissueAddress:
            state.reportShipToAddressReducer.outsideShipToAddress
                .nonTissueAddress,
        tissueAddress:
            state.reportShipToAddressReducer.outsideShipToAddress.tissueAddress,
        selectedAccount: state.reportShipToAddressReducer.selectedAccount,
        shipToAddressLoading: state.reportShipToAddressReducer.loading,
    }));

    const closekeyBoard = () => {
        document.activeElement.blur();
    };
    const [initialLoad, setInitialLoad] = useState(true);
    const [shipToInputValue, setshipToInputValue] = useState(null);

    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;
    const physicianRef = useRef();
    const {
        accountsOptionLoading,
        physiciansOptionLoading,
        billToLoading,
        transferRecipientLoading,
    } = useSelector((state) => ({
        accountsOptionLoading: state.detailsDropdownsReducer.accounts.loading,
        physiciansOptionLoading:
            state.detailsDropdownsReducer.physicianList.loading,
        billToLoading: state.detailsDropdownsReducer.billToDetails.loading,
        transferRecipientLoading: state.usageTransferRecipientReducer.loading,
    }));

    const japanMinimunDate = getMinimumDatesBasedOnJapanTime(
        new Date(),
        requestedDeliveryDateCutOffTime,
        AccountId
    );
    const [defaultPhysicianValue, setDefaultPhysicianValue] = useState('');
    const RequestDeliveryDate = useSelector(
        (state) => state.reportUsageRootReducer.requestDeliveryDate
    );
    const SurgeryDate = useSelector(
        (state) => state.reportUsageRootReducer.surgeryDate
    );
    const showShippingMethod = useSelector((state) => {
        return state.reportShippingMethodsReducer.showShippingMethods;
    });

    const { shippingMethod } = useSelector((state) => ({
        shippingMethod:
            state.reportShippingMethodsReducer.outsideShippingMethods.S002,
    }));
    // const [requestDeliveryDate, setRequestDeliveryDate] = useState('');
    // const [shippingMethodValue, setShippingMethodValue] = useState('');
    //const [selectedShipTo, setSelectedShipTo] = useState('');
    const [enableAddressButton, setEnableAddressButton] = useState(false);
    const [attnErrorMsg, setAttnErrorMsg] = useState('');

    const [selectedCard, setSelectedCard] = useState('');
    const [selectedValue, setInputValue] = useState('');
    const transferRecipient = useSelector(
        (state) => state.usageTransferRecipientReducer.transferRecipient
    );
    //const [usageTransferRecipient, setUsageTransferRecipient] = useState('');
    const [selectedBillTo, setSelectedBillTo] = useState('');
    const [disableFieldsBillTo, setDisableFieldsBillTo] = useState(false);
    const [selectedBillToId, setSelectedBillToId] = useState('');
    const {
        billToReportUsageVisibility,
        billToReportUsageMandatory,
        billToShipToPartnerRole,
        attnFieldVisibility,
        transferRecipientMeta,
        transferRecipientMandatory,
        careOfFieldVisibilityZLCR,
        careOfFieldMandatory,
        physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageReplenishmentMandatory,
    } = useSelector((state) => state.loginReducer);
    const productsWithError = useSelector(
        (state) => state.reportUsageRootReducer.productsWithError
    );
    useEffectWithErrorLogging(() => {
        if (shipToClick) {
            ApplyShipToAddress();
        }
    }, [applyClickOutside]);

    useEffectWithErrorLogging(() => {
        if (selectedAccount) {
            setInputValue(
                selectedAccount?.accountId?.accountFormattedName ||
                    selectedAccount?.accountFormattedName
            ); 
            dispatch(setUsageSurgeryOutsideAction(selectedAccount));
        }
        if (surgeryDetails?.billToId) {
            setSelectedBillTo(surgeryDetails?.billToId?.billToFormattedName);
        }
    }, [territory]);
    const [disableFields, setDisableFields] = useState({
        account: false,
        physician: false,
        template: false,
        billToId: false,
        // physicianTextBox: physicianTextBoxType === 'unknown',
    });

    const showOptionsAfterClose = (value) => {
        setTimeout(() => {
            try {
            handleDisableField(value, true);
             } catch (error) {
              logErrorToConsole(error);
              }
        }, 700);
    };
    const handleDisableField = (fieldName, value) => {
        setDisableFields({
            ...disableFields,
            [fieldName]: value,
        });
    };
    const handleInputChangee = (name, value) => {
        if (name == 'physicianId') {
            getPhysicanList({
                isLoadAll: false,
                searchValue: value,
                type: physiciantype === 'favorites' ? 'favorites' : 'All',
                sapPartnerId: surgeryDetails?.accountId?.accountId,
            });
            dispatch(
                setUsageSurgeryOutsideAction({
                    physicianId: value,
                })
            );

            return;
        }
    };
    const [physiciantype, setPhysicianType] = useState('favorites');
    const [physicianInputValue, setPhysicianValue] = useState('');
    const [disableFormFields, setDisableFormFields] = useState(false);
    const [loadAllPhysician, setloadAllPhysician] = useState(false);
    // const{ physicianId} = surgeryDetailss;
    const getPhysicanList = (data) => {
        const { searchValue, isLoadAll, forceLoadAll } = data;
        let params = {
            physicianType: data.type
                ? data.type
                : physiciantype == 'favorites'
                ? 'favorites'
                : 'All',
            isLoadAll:
                forceLoadAll ?? searchLoadAll ? searchLoadAll : isLoadAll,
            searchTerm: searchValue ? searchValue : '',
            sapPartnerId: surgeryDetails?.accountId?.accountId,
        };
        if (params.physicianType === 'All') {
            setloadAllPhysician(true);
        } else {
            setloadAllPhysician(false);
        }
        dispatch(
            getDropdownOptionsRequest(
                'physicians',
                params,
                salesOrg,
                countryISOCode
            )
        );
        // dispatch(
        //     getDropdownValues({
        //         dropDownName: 'physicianList',
        //         value: params,
        //         salesOrg: salesOrg,
        //         countryISOCode: countryISOCode,
        //     })
        // );
    };
    const [searchLoadAll, setSearchLoadAll] = useState(false);
    const handleLoadAll = (loadAnimation) => {
        // setPhysicianValue('');
        setSearchLoadAll(true);
        getPhysicanList({
            searchValue: '',
            isLoadAll: true,
            type: physiciantype === 'favorites' ? 'favorites' : 'All',
            sapPartnerId: surgeryDetails?.accountId?.accountId,
        });
    };
    const AccountTemplatee = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                data={physicianDetails || []}
                optionValue={'physicianId'}
                fieldname={fieldname}
                onLoadMore={() => handleLoadAll(true)}
                showLoadMore={loadAllPhysician}
                showOptionLoader={false}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };

    const physicianTypeChange = (type, fromSwitch = false) => {
        setPhysicianType(type);
        setSearchLoadAll(false);
        if (!fromSwitch) {
            setPhysicianValue('');
            // handleInputChangee('physicianId', '');
            handleDisableField('physician', true);
        }
        dispatch(
            clearSingleDropDownList({
                name: 'physicians',
            })
        );

        getPhysicanList({
            forceLoadAll: false,
            searchValue: '',
            isLoadAll: false,
            type: type === 'favorites' ? 'favorites' : 'All',
            sapPartnerId: surgeryDetails?.accountId?.accountId,
        });
    };
    const handleSearche = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            let option = {
                searchValue: value?.trim() || '',
                sapPartnerId: surgeryDetails?.accountId?.accountId,
            };
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                debouncedGetList(getPhysicanList, option);
            }
        } else {
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                handleInputChangee(
                    'physicianDropDown',
                    physiciantype === 'favorites' ? 'Favorites' : 'All'
                );
                getPhysicanList({
                    isLoadAll: false,
                    searchValue: '',
                    type: physiciantype === 'favorites' ? 'favorites' : 'All',
                    sapPartnerId: surgeryDetails?.accountId?.accountId,
                });
            }
        }
    };

    useEffectWithErrorLogging(() => {
        if (selectedList) {
            setInputValue(selectedList?.accountFormattedName); 
            dispatch(setUsageSurgeryOutsideAction(selectedList));
            dispatch(setSelectedOutsideAccount(selectedList));
        }
    }, [selectedList]);

    useEffectWithErrorLogging(() => {
        dispatch(getDropdownValues({ dropDownName: 'accountLookup' }));
    }, []);

    useEffectWithErrorLogging(() => {
        if (billToDetails) {
            if (billToDetails.length === 1) {
                setSelectedBillTo(
                    billToDetails[0].billToFormattedName
                        ? billToDetails[0].billToFormattedName
                        : ''
                );
                setSelectedBillToId(billToDetails[0]);
                const object = {
                    ['billToId']: billToDetails[0],
                };
                dispatch(setUsageSurgeryOutsideAction(object));
            }
        }
    }, [billToDetails, territory]);

    useEffectWithErrorLogging(() => {
        if (nonTissueAddress !== undefined) {
            if (nonTissueAddress.length !== 0) {
                return { nonTissueAddress, ...tissueAddress };
            }
        }
    }, [nonTissueAddress]);

    useEffectWithErrorLogging(() => {
        if (nonTissueAddress !== undefined) {
            if (nonTissueAddress.length === 0) {
                setSelectedCard('');
                setSelectedShipTo('');
                setshipToInputValue(null);
                setShippingMethodValue('');
                return;
            }

            if (nonTissueAddress.length > 1) {
                const hasDefaultAddress = nonTissueAddress.some(
                    (element) => element.defaultAddress
                );

                if (!hasDefaultAddress) {
                    const isSelectedShipToStillValid =
                        Boolean(selectedShipTo?.shippingAddressId) &&
                        nonTissueAddress.some(
                            (address) =>
                                address?.shippingAddressId ===
                                selectedShipTo?.shippingAddressId
                        );

                    if (!isSelectedShipToStillValid) {
                        setSelectedCard('');
                        setSelectedShipTo('');
                        setshipToInputValue(null);
                        setShippingMethodValue('');
                    }
                }
            }

            if (nonTissueAddress.length !== 0 && nonTissueAddress.length > 1) {
                nonTissueAddress.forEach((element, index) => {
                    if (element.defaultAddress) {
                        // defaultAddress = element;
                        if (initialLoad) {
                            setshipToInputValue(element);
                            handleShippingToCardClick(
                                element,
                                element.accountId
                            );
                            setInitialLoad(false);
                        }
                        let shippingPayload =
                            // countryISOCode === COUNTRY_CODE_JAPN
                            //     ?
                            {
                                orderType: 'ZLC',
                                shipToAcc: element?.shippingAddressId,
                                salesOrg: element.salesOrg,
                                isOutside: true,
                                surgeryDate: surgeryDate
                                    ? getRddDate(SurgeryDate)
                                    : '',
                                requestDeliveryDate:
                                    countryISOCode !== 'US'
                                        ? RequestDeliveryDate
                                            ? getRddDate(RequestDeliveryDate)
                                            : ''
                                        : '',

                                currentDate: getJapanCurrentDateTime(
                                    countryISOCode === COUNTRY_CODE_JAPN
                                        ? '540'
                                        : surgeryDetails?.accountId
                                              ?.timeZoneOffset,
                                    surgeryDetails?.accountId?.accountTimeZone,
                                    true
                                ),

                                requestedDeliveryDateMandatoryRule:
                                    countryISOCode !== 'US'
                                        ? requestedDeliveryDateMandatory ===
                                          'YES'
                                            ? 'YES'
                                            : 'NO'
                                        : '',
                                requestedDeliveryDateVisbility:
                                    countryISOCode !== 'US'
                                        ? requestedDeliveryDateVisibility ===
                                          VISIBLE
                                            ? 'YES'
                                            : 'NO'
                                        : '',
                            };
                        // : {
                        //       orderType: 'ZLC',
                        //       shipToAcc: element?.shippingAddressId,
                        //       salesOrg: element.salesOrg,
                        //       isOutside: true,
                        //   };
                        setSelectedCard(index);
                        setSelectedShipTo(element);
                        dispatch(getShippingMethods(shippingPayload));
                    }
                });
            } else if (
                nonTissueAddress.length !== 0 &&
                nonTissueAddress.length === 1
            ) {
                let shippingPayload =
                    // countryISOCode === COUNTRY_CODE_JAPN
                    //     ?
                    {
                        orderType: 'ZLC',
                        shipToAcc: nonTissueAddress[0]?.shippingAddressId
                            ? nonTissueAddress[0].shippingAddressId
                            : null,
                        salesOrg: nonTissueAddress[0]?.salesOrg,
                        isOutside: true,
                        surgeryDate: surgeryDate ? getRddDate(SurgeryDate) : '',

                        requestDeliveryDate:
                            countryISOCode !== 'US'
                                ? RequestDeliveryDate
                                    ? getRddDate(RequestDeliveryDate)
                                    : ''
                                : '',
                        currentDate: getJapanCurrentDateTime(
                            countryISOCode === COUNTRY_CODE_JAPN
                                ? '540'
                                : surgeryDetails?.accountId?.timeZoneOffset,
                            surgeryDetails?.accountId?.accountTimeZone,
                            true
                        ),
                        requestedDeliveryDateMandatoryRule:
                            countryISOCode !== 'US'
                                ? requestedDeliveryDateMandatory === 'YES'
                                    ? 'YES'
                                    : 'NO'
                                : '',
                        requestedDeliveryDateVisbility:
                            countryISOCode !== 'US'
                                ? requestedDeliveryDateVisibility === VISIBLE
                                    ? 'YES'
                                    : 'NO'
                                : '',
                    };
                // : {
                //       orderType: 'ZLC',
                //       shipToAcc: nonTissueAddress[0]?.shippingAddressId
                //           ? nonTissueAddress[0].shippingAddressId
                //           : null,
                //       salesOrg: nonTissueAddress[0]?.salesOrg,
                //       isOutside: true,
                //   };

                if (initialLoad) {
                    setshipToInputValue(nonTissueAddress[0]);
                    handleShippingToCardClick(
                        nonTissueAddress[0],
                        nonTissueAddress[0].accountId
                    );
                    setInitialLoad(false);
                }
                setSelectedCard(0);
                setSelectedShipTo(nonTissueAddress[0]);
                dispatch(getShippingMethods(shippingPayload));
            }
            if (
                nonTissueAddress.length !== 0 &&
                nonTissueAddress.length > 1 &&
                (requestedDeliveryDateMandatory === 'YES'
                    ? RequestDeliveryDate
                    : true)
            ) {
                if (selectedShipTo?.shippingAddressId) {
                    let shippingPayload = {
                        orderType: 'ZLC',
                        shipToAcc: selectedShipTo?.shippingAddressId
                            ? selectedShipTo?.shippingAddressId
                            : null,

                        salesOrg: selectedShipTo?.salesOrg
                            ? selectedShipTo?.salesOrg
                            : salesOrg
                            ? salesOrg
                            : null,
                        isOutside: true,
                        surgeryDate: surgeryDate ? SurgeryDate : '',
                        requestDeliveryDate:
                            countryISOCode !== 'US'
                                ? RequestDeliveryDate
                                    ? getRddDate(RequestDeliveryDate)
                                    : ''
                                : '',
                        currentDate: getJapanCurrentDateTime(
                            countryISOCode === COUNTRY_CODE_JAPN
                                ? '540'
                                : surgeryDetails?.accountId?.timeZoneOffset,
                            surgeryDetails?.accountId?.accountTimeZone,
                            true
                        ),
                        requestedDeliveryDateMandatoryRule:
                            countryISOCode !== 'US'
                                ? requestedDeliveryDateMandatory === 'YES'
                                    ? 'YES'
                                    : 'NO'
                                : '',
                        requestedDeliveryDateVisbility:
                            countryISOCode !== 'US'
                                ? requestedDeliveryDateVisibility === VISIBLE
                                    ? 'YES'
                                    : 'NO'
                                : '',
                    };

                    dispatch(getShippingMethods(shippingPayload));
                }
            }
        }
    }, [
        nonTissueAddress,
        RequestDeliveryDate,
        surgeryDetails?.accountId?.accountId,
    ]);

    useEffectWithErrorLogging(() => {
        if (
            surgeryDetails?.accountId !== undefined &&
            surgeryDetails.accountId !== '' &&
            territory === OutsideTerritory() &&
            surgeryDetails.billToId !== '' &&
            surgeryDetails.billToId !== undefined
        ) {
            dispatch(getShipToAddress({ isInside: false, searchValue: '' }));
            setSelectedShipTo('');
            setShippingMethodValue('');
            getTransferRecipientList({ searchAccountParam: '' });
        } else if (
            surgeryDetails?.accountId !== undefined &&
            surgeryDetails.accountId !== '' &&
            territory === OutsideTerritory() &&
            billToShipToPartnerRole !== 'BILL_TO'
        ) {
            dispatch(getShipToAddress({ isInside: false, searchValue: '' }));
            setShippingMethodValue('');
        }
    }, [surgeryDetails, territory]);

    useEffectWithErrorLogging(() => {
        if (shippingMethod && shippingMethod.length) {
            const defalutVal = shippingMethod.filter(
                (item) => item.isDefaultSelected
            );
            setShippingMethodValue(
                defalutVal.length ? defalutVal[0] : shippingMethod[0]
            );
            const attnLineDefault =
                shippingMethod &&
                shippingMethod.filter((item) => item.attnLine);
            setAttnValue(
                attnLineDefault.length > 0 ? attnLineDefault[0].attnLine : ''
            );
        }
    }, [shippingMethod]);

    const [expandedCard, setExpandedCard] = useState({
        district: false,
        shipping: true,
    });
    const emptyAddressObj = {
        addressId: '',
        salesOrg: '',
        attention: '',
        shippingAddressId: '',
        formattedShippingAddressId: '',
    };

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const handleOnfocus = (event, field) => {
        if (field == 'accounts' && selectedAccount !== '') {
            getAccountList({
                searchValue:
                    selectedAccount || event?.target?.value?.trim() || '',
            });
        } else if (field == 'billToId') {
            getBillToDetailsList({
                searchValue: '',
            });
        } else {
            getAccountList({
                searchValue: '',
            });
        }
    };

    const getAccountList = (data) => {
        const { searchValue } = data;
        dispatch(
            getDropdownValues({
                dropDownName: 'accountLookup',
                value: { accountName: searchValue },
            })
        );
    };

    const getBillToDetailsList = (data) => {
        const { searchValue = '' } = data;
        let params = {
            sapPartnerId: selectedAccount?.accountId?.accountId,
            searchValue,
        };
        dispatch(
            getDropdownValues({ dropDownName: 'billToDetails', value: params })
        );
    };

    const handleInputChanges = (ev, value, isClear, name) => {
        if(ev) ev?.preventDefault();
        const object = {
            [name]: value,
        };
        if (name == 'accountId') {
            setInputValue(object?.accountFormattedName);
            setAccountData(object);
            if (billToReportUsageVisibility == 'VISIBLE') {
                const data = {
                    sapPartnerId: value?.accountId,
                };
                data.sapPartnerId && dispatch(
                    getDropdownValues({
                        dropDownName: 'billToDetails',
                        value: data,
                    })
                );
            }
        }
        if (
            !value ||
            (selectedAccount &&
                value?.accountId &&
                selectedAccount?.accountId &&
                selectedAccount.accountId !== value.accountId)
        ) {
            setSelectedCard('');
            setSelectedShipTo('');
            setAttnValue('');
            setSelectedBillTo('');
            setDisableFieldsBillTo(false);
        }

        if (name == 'billToId') {
            setSelectedBillTo(value ? value?.billToFormattedName : '');
            setSelectedBillToId(value);
            const data = {
                sapPartnerId: selectedAccount?.accountId?.accountId,
            };
            dispatch(
                getDropdownValues({
                    dropDownName: 'billToDetails',
                    value: data,
                })
            );
        }

        if (isClear !== 'clear' && isClear !== 'reset' && value) {
            setSelectedCard('');
            if (name == 'accountId') {
                dispatch(setSelectedOutsideAccount(object));
                setAccountData(object);
            }
            dispatch(setUsageSurgeryOutsideAction(object));
        } else if (name == 'accountId' && (value == null || value == ''||isClear==='clear')) {
            dispatch(setSelectedOutsideAccount(''));
            setSelectedList('');
            dispatch(clearOutsideShippingAddress());
            setAttnValue('');
            setSelectedBillToId('');
            setDisableFieldsBillTo(false);
            setPhysicianValue('');
            setDefaultPhysicianValue('');
            dispatch(setUsageSurgeryOutsideAction({ physicianId: '' }));
            dispatch(clearSingleDropDownList({ name: 'physicians' }));
        } else if (name == 'billToId' && (value == null || value == '')) {
            dispatch(setUsageSurgeryOutsideAction(object));
            dispatch(clearOutsideShippingAddressWhenBillToCleared());
        }
    };

    const handleSearch = (event, value, reason, fieldname) => {
        // setInputValue(value); 
        if (reason === 'clear' || reason === 'reset' || !value) {
            setSelectedList('');
            setAttnValue('');
            if (fieldname == 'account') { 
                setInputValue('');
                setSelectedBillTo('');
                dispatch(setSelectedOutsideAccount(''));
                // Clear physician field when account is cleared
                setPhysicianValue('');
                setDefaultPhysicianValue('');
                dispatch(setUsageSurgeryOutsideAction({ physicianId: '' }));
                dispatch(clearSingleDropDownList({ name: 'physicians' }));
                dispatch(clearOutsideShippingAddress());
            }
            if (fieldname == 'billToId') {
                setSelectedBillTo(value);
                const object = {
                    [fieldname]: value,
                };
                dispatch(setUsageSurgeryOutsideAction(object));
                dispatch(clearOutsideShippingAddressWhenBillToCleared());
            }
        } else if (reason !== 'reset') {
            let option = {
                searchValue: value?.trim() || '',
            };
            if (fieldname == 'account') {
                setInputValue(value); 
                debouncedGetList(getAccountList, option);
                setDisableFieldsBillTo(false);
            }
            if (fieldname == 'billToId') {
                setSelectedBillTo(value);
                debouncedGetList(getBillToDetailsList, option);
            }
            if (fieldname == 'account' && value == '') {
                dispatch(clearInsideShippingAddress());
                setAttnValue('');
                setSelectedBillTo('');
            }
            if (fieldname == 'billToId' && value == '') {
                setSelectedBillTo('');
                setSelectedBillToId('');
                dispatch(clearOutsideShippingAddressWhenBillToCleared());
            }
        } else {
            if (fieldname == 'account') {
                setSelectedBillTo('');
                setSelectedBillToId('');
                setDisableFieldsBillTo(false);
            }
            if (fieldname == 'account' && value == '') {
                dispatch(clearInsideShippingAddress());
                setAttnValue('');
                setCareOfValue('');
                setSelectedBillTo('');
            } else if (fieldname == 'billToId' && value == '') {
                setSelectedBillTo('');
                dispatch(clearOutsideShippingAddressWhenBillToCleared());
            }
        }
    };

    //     return (
    //         <AccountPhysicianTemplate
    //             option={option}
    //             data={fieldname == 'account' ? accounts : physicians}
    //             optionValue={
    //                 fieldname == 'account' ? 'accountId' : 'physicianId'
    //             }
    //             fieldname={fieldname}
    //             onLoadMore={() => handleLoadAll(true)}
    //             showLoadMore={!loadAll}
    //             showOptionLoader={physicianLoadAllLoading}
    //             physiciantype={physiciantype}
    //             physicianInputValue={inputValue}
    //         />
    //     );
    // };
    const AccountTemplate = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                data={fieldname == 'account' ? accounts : []}
                optionValue={
                    fieldname == 'account' ? 'accountId' : 'physicianId'
                }
                fieldname={fieldname}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };
    const optionValues = accounts.length !== 0 ? accounts : [];

    const OptionBillTo = (option) => {
        return (
            <>
                <OptionContainer>
                    <div
                        style={{
                            width: '85%',
                            cursor: 'pointer',
                        }}
                    >
                        <label
                            className="template"
                            style={{ cursor: 'pointer' }}
                        >
                            {option.billToFormattedName}
                        </label>
                    </div>
                </OptionContainer>
            </>
        );
    };

    const ApplyShipToAddress = () => {
        onClose();
        const modifiedGridData = gridData.map((item) => {
            const updatedItem = { ...item };
            if (
                item.isSelected &&
                !item.accountOwned &&
                !productsWithError.includes(item.cfn)
            ) {
                updatedItem.shippingDetails = {
                    shippingAddress: selectedShipTo,
                    shippingMethod: shippingMethodValue,
                    accountDetails:
                        typeof surgeryDetails?.accountId === 'object'
                            ? surgeryDetails?.accountId
                            : { accountId: surgeryDetails?.accountId },
                    attnLine: attnValue,
                    careOf: careOfValue,
                    transferRecipient: usageTransferRecipient,
                    requestDeliveryDate:
                        RequestDeliveryDate !== ''
                            ? getRddDate(RequestDeliveryDate)
                            : '',
                    surgeryDate:
                        SurgeryDate !== '' ? getRddDate(SurgeryDate) : '',
                    surgeryNumber:
                        replenishmentSurgeryNumber !== ''
                            ? replenishmentSurgeryNumber
                            : '',
                    billToId: selectedBillToId?.billToNumber,
                    isOutSide: true,
                };
            }
            updatedItem.isSelected = false;
            return updatedItem;
        });
        setGridData(modifiedGridData);
        dispatch(setShippingDetails(modifiedGridData));
        dispatch(clearValidateReplenData());
    };

    const canCallShippingMethod = () => {
        const isSurgeryDateAvailable = !!surgeryDate;
        const isRddAvailable = !!RequestDeliveryDate;
        const isRequestDeliveryMandatory =
            requestedDeliveryDateVisibility === VISIBLE &&
            (requestedDeliveryDateMandatory === 'YES' || requestedDeliveryDateMandatory === 'Yes');

        return (
            (isSurgeryDateMandate && isRequestDeliveryMandatory && isSurgeryDateAvailable && isRddAvailable) ||
            (!isSurgeryDateMandate && isRequestDeliveryMandatory && isRddAvailable) ||
            (isSurgeryDateMandate && !isRequestDeliveryMandatory && isSurgeryDateAvailable) ||
            (!isSurgeryDateMandate && !isRequestDeliveryMandatory)
        );
    };

    const handleShippingToCardClick = (item, index) => {
        let shippingPayload =
            // countryISOCode === COUNTRY_CODE_JAPN
            //     ?
            {
                orderType: 'ZLC',
                shipToAcc: item.shippingAddressId,
                salesOrg: item.salesOrg,
                isOutside: true,
                surgeryDate: surgeryDate ? getRddDate(SurgeryDate) : '',

                requestDeliveryDate:
                    countryISOCode !== 'US'
                        ? RequestDeliveryDate
                            ? getRddDate(RequestDeliveryDate)
                            : ''
                        : '',
                currentDate: getJapanCurrentDateTime(
                    countryISOCode === COUNTRY_CODE_JAPN
                        ? '540'
                        : surgeryDetails?.accountId?.timeZoneOffset,
                    surgeryDetails?.accountId?.accountTimeZone,
                    true
                ),
                requestedDeliveryDateMandatoryRule:
                    countryISOCode !== 'US'
                        ? requestedDeliveryDateMandatory === 'YES'
                            ? 'YES'
                            : 'NO'
                        : '',
                requestedDeliveryDateVisbility:
                    countryISOCode !== 'US'
                        ? requestedDeliveryDateVisibility === VISIBLE
                            ? 'YES'
                            : 'NO'
                        : '',
            };
        // : {
        //       orderType: 'ZLC',
        //       shipToAcc: item.shippingAddressId,
        //       salesOrg: item.salesOrg,
        //       isOutside: true,
        //   };

        if (canCallShippingMethod()) {
            dispatch(getShippingMethods(shippingPayload));
        }
        setSelectedShipTo(item);
        setSelectedCard(index);
        setShippingMethodValue('');
    };

    useEffectWithErrorLogging(() => {
        if (
            selectedShipTo !== '' &&
            (isCondensedView
                ? shipToInputValue?.formattedShippingAddressId !== ''
                : true) &&
            (countryISOCode === COUNTRY_CODE_JAPN
                ? !showShippingMethod
                    ? Object.keys(shippingMethodValue).length > 1 &&
                      shippingMethodValue != ''
                    : false
                : shippingMethodValue != '') &&
            surgeryDetails?.accountId !== undefined &&
            surgeryDetails?.accountId !== '' &&
            selectedValue !== '' &&
            (physicianDropdownZGReportUsageReplenishmentVisibility !=
                'VISIBLE' ||
                physicianDropdownZGReportUsageReplenishmentMandatory !==
                    'YES' ||
                (surgeryDetails?.physicianId !== undefined &&
                    surgeryDetails.physicianId !== '')) &&
            ((requestedDeliveryDateMandatory !== 'YES' &&
                requestedDeliveryDateMandatory !== 'Yes') ||
                isRequestDeliveryMandate) &&
            ((usageReplenishmentSurgeryDateMandatoryRule !== 'YES' &&
                usageReplenishmentSurgeryDateMandatoryRule !== 'Yes') ||
                isSurgeryDateMandate) &&
            (selectedAccount !== '' || Boolean(surgeryDetails?.accountId)) &&
            isSurgeryNumberMandate &&
            ((careOfFieldMandatory == MANDATORY && careOfValue !== '') ||
                careOfFieldMandatory !== MANDATORY) &&
            ((transferRecipientMandatory == MANDATORY && usageTransferRecipient?.addressId !== undefined) || 
                transferRecipientMandatory !== MANDATORY || !transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId)) &&
            !attnErrorMsg
        ) {
            setEnableAddressButton(true);
        } else {
            setEnableAddressButton(false);
        }
    }, [
        selectedShipTo,
        shipToInputValue,
        shippingMethodValue,
        showShippingMethod,
        surgeryDetails?.accountId,
        surgeryDetails?.physicianId,
        selectedValue,
        selectedAccount,
        requestDeliveryDate,
        requestedDeliveryDateMandatory,
        requestedDeliveryDateVisibility,
        isRequestDeliveryMandate,
        careOfValue,
        careOfFieldMandatory,
        isSurgeryNumberMandate,
        transferRecipientMandatory,
        usageTransferRecipient,
        transferRecipientMeta,
        usageReplenishmentSurgeryDateMandatoryRule,
        isSurgeryDateMandate,
        physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageReplenishmentMandatory,
        countryISOCode,
        attnErrorMsg,
    ]);
    const [transferRecipientValue, setTransferRecipientValue] = useState('');
    const [transferRecipientSelectedValue, setTransferRecipientSelectedValue] =
        useState('');
    const [openTransferRecipientDropdown, setOpenTransferRecipientDropdown] =
        useState('');
    // const [shipToAddresstValue, setShipToAddresstValue] = useState('');
    const [openShipToAddressDropdown, setOpenShipToAddressDropdown] =
        useState('');

    const OptionTransferRecipient = (option) => {
        return (
            <>
                <OptionContainer>
                    <div
                        style={{
                            width: '85%',
                            cursor: 'pointer',
                        }}
                    >
                        <label
                            className="template"
                            style={{ cursor: 'pointer' }}
                        >
                            {option.accountName}
                        </label>
                    </div>
                </OptionContainer>
            </>
        );
    };

    const ShipToOptionTemplate = (option, fieldname) => {
        return <ShipToTemplate option={option} fieldname={'shipTo'} />;
    };

    const getTransferRecipientList = (data) => {
        const { searchAccountParam = '' } = data;
        let params = {
            sapPartnerId: surgeryDetails?.accountId?.accountId
                ? surgeryDetails?.accountId?.accountId
                : surgeryDetails?.accountId,
            shippingMethodSelected: shippingMethodValue?.shippingMethodId,
            searchAccountParam,
        };
        dispatch(getTransferRecipientMethods(params));
    };

    const getShipToAddressList = (value) => {
        dispatch(getShipToAddress({ isInside: false, searchValue: value }));
    };

    const handleTransferRecipient = (field, event, value, reason) => {
        if (field == 'handleSearch') {
            if (reason !== 'reset') {
                let option = {
                    searchAccountParam: value?.trim() || '',
                };
                setTransferRecipientValue(value);
                setTransferRecipientSelectedValue(value);
                debouncedGetList(getTransferRecipientList, option);
            } else {
                setTransferRecipientValue(value);
                setTransferRecipientSelectedValue(value);
            }
        }
        if (field == 'handleInputChange') {
            setUsageTransferRecipient(value);
            setTransferRecipientValue(value);
        }
        if (field == 'handleOnFocus') {
            const params = {
                sapPartnerId: surgeryDetails?.accountId?.accountId,
                shippingMethodSelected: shippingMethodValue?.shippingMethodId,
            };
            dispatch(getTransferRecipientMethods(params));
            getTransferRecipientList(params);
            setOpenTransferRecipientDropdown(true);
        }

        if (field == 'handleDisableField') {
            setOpenTransferRecipientDropdown(value);
        }
    };
    const handleShipToAddress = (field, event, value, reason) => {
        if (field == 'handleSearch' && value !== undefined) {
            if (reason !== 'reset') {
                const searchAccountParam = value?.trim() || '';
                setshipToInputValue({ searchValue: searchAccountParam });
                debouncedGetList(getShipToAddressList, searchAccountParam);
            } else {
                setshipToInputValue({ searchValue: value });
            }
        }
        if (field == 'handleInputChange') {
            if (!value) {
                setSelectedShipTo('');
                getShipToAddressList('');
                setshipToInputValue(emptyAddressObj);
            } else {
                setshipToInputValue(value);
                handleShippingToCardClick(value, value?.accountId);
                setSelectedShipTo(value);
            }
        }
        if (field == 'handleOnFocus') {
            getShipToAddressList('');
            setOpenShipToAddressDropdown(true);
        }

        if (field == 'handleDisableField') {
            setOpenShipToAddressDropdown(value);
        }
    };
    const renderNoOption = (
        <OptionalLoadMoreView
            height={physiciantype == 'All' ? '200px' : '158px'}
        >
            {physiciantype == 'All' ? (
                <>
                    <p
                        style={{
                            fontSize: '12px',
                            marginBottom: '5px',
                        }}
                    >
                        {t('scheduleSurgery.details.notRecetPhysicianMSG')}
                        <br></br>
                        {t(
                            'scheduleSurgery.details.trySearchingByTypeMSG'
                        )}{' '}
                    </p>
                    <p>
                        {t('scheduleSurgery.details.cantFindWhoYou')}
                        <br></br>
                        {t('scheduleSurgery.details.areLookingFor')}{' '}
                    </p>
                    <button
                        onMouseDown={() => {
                            try {
                            handleLoadAll(true);
                            } catch (error) {
                              logErrorToConsole(error);
                           }
                        }}
                    >
                        {t('scheduleSurgery.details.loadAllPhysicians')}
                    </button>
                </>
            ) : (
                <>
                    <p
                        style={{
                            marginBottom: '7px',
                        }}
                    >
                        {t('scheduleSurgery.details.noFavoritePhysuciansSet')}
                    </p>
                    <button
                        style={{ width: '236px', fontSize: '15px' }}
                        onMouseDown={() => {
                            try {
                            physicianTypeChange(
                                physiciantype === 'All' ? 'favorites' : 'All',
                                true
                            );
                            } catch (error) {
                                 logErrorToConsole(error);
                             }
                        }}
                    >
                        {t(
                            'scheduleSurgery.details.switchToTerritoryPhysicians'
                        )}
                    </button>
                </>
            )}
        </OptionalLoadMoreView>
                                );
    return (
        <>
            {' '}
            <DetailsMainContainer>
                <MainContainerThird>
                    <FlexDiv>
                        <MainContainerSecond flex="52%" marginBottom="16px">
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Title showAstrisk={true}>
                                    {t('common.accountLabel')}
                                </Title>
                                {window.innerWidth < 500 && (
                                    <Title
                                        id="reportUsage-replen-selectShipToAddressOutside-advancedSearch-mobile"
                                        isCursor={true}
                                        color={'#1010EB'}
                                        onClick={advanceSearch}
                                    >
                                        {t(
                                            'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.advancedSearchTitle'
                                        )}
                                    </Title>
                                )}
                            </div> 
                            <AutoComplete
                                customWidth={billToReportUsageVisibility == 'VISIBLE'?
                                    '98%':'53.5%'}
                                inputRef={
                                    accountRef
                                }
                                showScrollBar={true}
                                disableClearable={
                                    false
                                }
                                isFullWidth={true}  
                                options={
                                    accounts &&
                                    accounts?.length >
                                        0
                                        ? accounts
                                        : []
                                }
                                value={accountData?.accountId
                                    ? accountData?.accountId
                                    : selectedAccount?.accountId
                                        ? selectedAccount?.accountId
                                        : ''
                                }
                                inputValue={ accountData?.accountId?.accountFormattedName || 
                                    selectedValue || ''
                                }
                                itemTemplate={(option) =>
                                      AccountTemplate(option, 'account')
                                }
                                hideNoOptionText={
                                    false
                                }
                                noOptionsText={
                                    !accountsOptionLoading &&
                                    accounts?.length ===
                                        0
                                        ? t(
                                                'calendar.filterResultsPanel.noOptionText'
                                            )
                                        : accountsOptionLoading &&
                                            t(
                                                'common.loadingText'
                                            )
                                }
                                placeholder={t(
                                    'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.selectAccount'
                                )}
                                field="accountFormattedName" 
                                optionValue="accountFormattedName"
                                id="reportUsage-replen-selectShipToOutside-account"
                                loading={accountsOptionLoading}
                                onChange={(
                                    value,
                                    reason
                                ) => { 
                                    if (
                                        reason ===
                                        'clear'
                                    ) {
                                        setInputValue('');
                                        handleSearch(
                                            '',
                                            '',
                                            reason,
                                            'account'); 
                                             setshipToInputValue(
                                                emptyAddressObj
                                            );
                                            setInitialLoad(true);
                                    }
                                    handleInputChanges(
                                            '',
                                            value,
                                            reason,
                                            'accountId'
                                        );
                                    if (
                                        value === ''
                                    )
                                        handleDisableField(
                                            'account',
                                            true
                                        );
                                }}
                                onInputChange={(
                                    event,
                                    value,
                                    reset
                                ) => {
                                    {
                                        // setInputValue(value || ''); 
                                        if (value) {
                                           handleSearch(
                                            event,
                                            value,
                                            reset,
                                            'account'
                                        );
                                        } else if (
                                            reset ===
                                            'clear'
                                        ) { 
                                            dispatch(
                                                setSelectedOutsideAccount('')
                                            );
                                            handleSearch(
                                            event,
                                            '',
                                            reset,
                                            'account'
                                        );
                                        }
                                    }
                                }}
                                onFocus={(event) =>
                                        handleOnfocus(event, 'accounts')
                                    }  
                                onOpen={() => {
                                    try {
                                    handleDisableField(
                                        'account',
                                        true
                                    ); 
                                     } catch (error) {
                                       logErrorToConsole(error);
                                     }
                                }}
                                onClose={() => {
                                    try {
                                    handleDisableField(
                                        'account',
                                        false
                                    );
                                     } catch (error) {
                                       logErrorToConsole(error);
                                     }
                                }}
                                open={
                                    accountData?.accountId?.accountFormattedName? false :
                                    disableFields.account
                                }
                                readOnly={Boolean(
                                    accountData?.accountId ||
                                    selectedAccount?.accountId ||
                                    surgeryDetails?.accountId
                                )
                                }
                                detailsMargin
                                marginLeft={'1.5px'}
                                clearOnBlur={false}
                                zIndex={'99999'}
                                ListboxProps={{
                                    style: {
                                        maxHeight:
                                            'auto',
                                    },
                                }}
                            />
                        </MainContainerSecond>
                        {billToReportUsageVisibility == 'VISIBLE' && (
                            <MainContainerSecond
                                marginLeft={
                                    window.innerWidth >= sizes.smalDevice
                                        ? '50px'
                                        : ''
                                }
                                marginBottom="16px"
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <Title
                                        showAstrisk={
                                            billToReportUsageMandatory == 'YES'
                                        }
                                    >
                                        {t('reportUsage.billToDetails.title')}
                                    </Title>
                                    {window.innerWidth > 500 && (
                                        <Title
                                            id="reportUsage-replen-selectShipToAddressOutside-advancedSearch-desktop"
                                            isCursor={true}
                                            color={'#1010EB'}
                                            onClick={advanceSearch}
                                        >
                                            {t(
                                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.advancedSearchTitle'
                                            )}
                                        </Title>
                                    )}
                                </div>
                                 
                                <AutoComplete
                                    inputRef={billToRef}
                                    showScrollBar={true}
                                    disableClearable={false}
                                    isFullWidth={true} 
                                    boxShadow={'0px 3px 6px #00000029'}
                                    options={ billToDetails &&
                                        billToDetails?.length >
                                            0
                                            ? billToDetails
                                            : []}
                                    value={
                                        selectedAccount ===
                                        ''
                                            ? ''
                                            : selectedBillTo
                                            ? selectedBillTo
                                            : ''
                                    }
                                    inputValue={
                                        selectedAccount === ''
                                            ? ''
                                            : selectedBillTo?.billToFormattedName?
                                            selectedBillTo?.billToFormattedName: 
                                            typeof (selectedBillTo) === 'string'?
                                            selectedBillTo
                                            : ''
                                        }
                                    clearOnBlur={false}
                                    itemTemplate={(option) =>  OptionBillTo(option)}
                                    onChange={(value, reason) => { 
                                        if (reason==='clear') {
                                            handleInputChanges(
                                                '',
                                                '',
                                                reason,
                                                'billToId'
                                            );
                                        }
                                        handleInputChanges(
                                            '',
                                            value ? value : '',
                                            reason,
                                            'billToId'
                                        );
                                        if(value==='')  setDisableFieldsBillTo(
                                            true
                                        );
                                    }}
                                    hideNoOptionText={false}
                                    placeholder={t(
                                        'equity.billToDetails.details.placeholder'
                                    )}
                                    field='billToFormattedName' 
                                    optionValue='billToFormattedName'
                                    id={'reportUsage-replen-selectShipToOutside-billTo'}
                                    onInputChange={(event, value, reset) => 
                                        {
                                            if(value){
                                               handleSearch(
                                                event,
                                                value ? value : '',
                                                reset,
                                                'billToId'
                                            );
                                            }
                                            else if(reset==='clear'){
                                                handleSearch(
                                                '',
                                                '',
                                                reset,
                                                'billToId'
                                            );
                                            }
                                        }     
                                    }
                                    loading={billToLoading}
                                    noOptionsText={
                                        !billToLoading &&
                                        billToDetails?.length === 0
                                            ? t(
                                                    'calendar.filterResultsPanel.noOptionText'
                                                )
                                            : billToLoading &&
                                                t('common.loadingText')
                                    }
                                    onFocus={(event) =>
                                            handleOnfocus(event, 'billToId')
                                        }
                                    disabled={selectedAccount == ''}
                                    onOpen={() => {
                                        try {
                                        if (selectedAccount === '') {
                                            setDisableFieldsBillTo(false);
                                        } else {
                                            setDisableFieldsBillTo(true);
                                        }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    onClose={() => {
                                        try {
                                        setDisableFieldsBillTo(false);
                                         } catch (error) {
                                           logErrorToConsole(error);
                                       }
                                    }}
                                    open={disableFieldsBillTo}
                                    readOnly={selectedBillTo}
                                    detailsMargin
                                    marginLeft={'1.5px'}
                                    zIndex={'99999'}
                                />
                            </MainContainerSecond>
                        )}
                        {window.innerWidth > 500 && billToReportUsageVisibility !== 'VISIBLE' && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                                <Title
                                    id="reportUsage-replen-selectShipToAddressOutside-advancedSearch-desktop"
                                    isCursor={true}
                                    color={'#1010EB'}
                                    onClick={advanceSearch}
                                >
                                    {t('reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.advancedSearchTitle')}
                                </Title>
                            </div>
                        )}
                    </FlexDiv>
                    {physicianDropdownZGReportUsageReplenishmentVisibility ===
                    'VISIBLE' ? (
                        <MainContainerSecond
                            isPhysician={true}
                            flex={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '1'
                                    : '52%'
                            }
                            setMarginBottom={true}
                            setMarginTop={
                                billToReportUsageVisibility === 'VISIBLE' &&
                                window.innerWidth <= sizes.mobileDevice
                                    ? '0px'
                                    : '20px'
                            }
                        >
                            <Title
                                showAstrisk={
                                    physicianDropdownZGReportUsageReplenishmentMandatory ===
                                    'YES'
                                }
                            >
                                {t('common.physicianLabel')}
                            </Title>
                            <RadioRowDiv marginBottom="15px">
                                <RadioButton
                                    isChecked={
                                        physiciantype == 'favorites' ||
                                        !physiciantype
                                            ? true
                                            : false
                                    }
                                    id={'favourites-label'}
                                    label={t('common.favoritesLabel')}
                                    handleChange={() => {
                                        try {
                                        !disableFormFields &&
                                            physicianTypeChange('favorites');
                                        // physicianRef.current?.focus();
                                         } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    value={physiciantype}
                                    fontFamilyStyle="AvenirNextWorld Regular"
                                    disabled={disableFormFields}
                                />
                                <RadioButton
                                    isChecked={
                                        physiciantype == 'All' ? true : false
                                    }
                                    id={'accounts-label'}
                                    label={
                                        salesOrg === 'S024' ||
                                        countryISOCode === 'JP'
                                            ? t('common.hospital')
                                            : t('common.accountLabel')
                                    }
                                    handleChange={() => {
                                        try {
                                        !disableFormFields &&
                                            physicianTypeChange('All');
                                        physicianRef.current?.focus();
                                         } catch (error) {
                                           logErrorToConsole(error);
                                         }
                                    }}
                                    value={physiciantype}
                                    fontFamilyStyle="AvenirNextWorld Regular"
                                    disabled={disableFormFields}
                                />
                            </RadioRowDiv>
                            <AutoCompleteContainer width="50%">
                                <AutoComplete
                                    mbWidth="100%"
                                    width={'93%'}
                                    showScrollBar={true}
                                    disableClearable={false}
                                    isPhysicianField={true}
                                    inputRef={physicianRef}
                                    noOptionStyle={true}
                                    value={surgeryDetails?.physicianId ?? ''}
                                    options={physicianDetails || []}
                                    itemTemplate={(option) =>
                                        AccountTemplatee(
                                            option,
                                            'physician',
                                            physiciantype,
                                            physicianInputValue
                                        )
                                    }
                                    placeholder={t(
                                        'common.selectOrSearchPhusician'
                                    )}
                                    field="physicianDisplayName"
                                    filterField="physicianFormattedName"
                                    optionValue="physicianId"
                                    onChange={(value, reason) => { 
                                        if (reason==='clear') {
                                            showOptionsAfterClose(
                                                'physician',
                                                true
                                            ); 
                                        }
                                        
                                        handleInputChangee(
                                            'physicianId',
                                            value
                                        );
                                        if (value == '') {
                                            setPhysicianValue('');
                                            handleDisableField(
                                                'physician',
                                                true
                                            );
                                        }
                                    }}
                                    id="reportUsage-replen-selectShipToOutside-physician"
                                    zIndex={1000000}
                                    loading={physiciansOptionLoading}
                                    onInputChange={(event, value, reset) => {
                                        if (value) { 
                                        handleSearche(
                                            event,
                                            value,
                                            reset,
                                            'physician'
                                        );
                                        }
                                        else if(reset==='clear'){
                                            handleSearche(
                                            '',
                                            '',
                                            reset,
                                            'physician'
                                        );
                                        }
                                    }}
                                    inputValue={physicianInputValue}
                                    loadingText={t('common.loadingText')}
                                    noOptionsText={
                                        physicianInputValue?.length >= 1
                                            ? null
                                            : renderNoOption
                                    }
                                    onOpen={() => {
                                        try {
                                        if (disableFormFields) {
                                            handleDisableField(
                                                'physician',
                                                false
                                            );
                                        } else {
                                            handleDisableField(
                                                'physician',
                                                true
                                            );
                                        }
                                         } catch (error) {
                                           logErrorToConsole(error);
                                         }
                                    }}
                                    onClose={() => {
                                        try {
                                        handleDisableField('physician', false);
                                         } catch (error) {
                                           logErrorToConsole(error);
                                         }
                                    }}
                                    open={surgeryDetails?.physicianId? false: disableFields.physician}
                                    readOnly={surgeryDetails?.physicianId}
                                    optionPadding={
                                        physicianInputValue?.length >= 1 &&
                                        physiciantype == 'All'
                                            ? '5px'
                                            : '0px'
                                    }
                                    detailsMargin
                                    hideNoOptionText={
                                        physiciantype != 'All' &&
                                        physicianInputValue?.length >= 1
                                            ? true
                                            : false
                                    }
                                    marginLeft={'1.5px'}
                                    style={{
                                        height: '40px',
                                        width: '100%',
                                    }}
                                />
                            </AutoCompleteContainer>
                        </MainContainerSecond>
                    ) : null}
                    <MainContainerSecond></MainContainerSecond>
                </MainContainerThird>
            </DetailsMainContainer>
            {selectedList == '' && accountData == '' && selectedValue == '' ? (
                <>
                    <AlertMsgShipToAccount>
                        {t(
                            'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.alertMsg'
                        )}{' '}
                    </AlertMsgShipToAccount>
                </>
            ) : (
                <>
                    <CollapsableCard id="reportUsage-selectShipToAddressOutside-selectShipToAddress-shippingLabel"
                        title={t(
                            'reportUsage.replen.selectShipToAddress.shippingLabel'
                        )}
                        onClick={() =>
                            toggleCard('shipping', !expandedCard.shipping)
                        }
                        isExpanded={expandedCard.shipping}
                        margin={'5px 0px 5px 0px'}
                        padding={
                            window.innerWidth > sizes.smalDevice
                                ? '20px 16px'
                                : ''
                        }
                    >
                        {expandedCard.shipping && (
                            <>
                                <Title showAstrisk={true}>
                                    {t(
                                        'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.shipToAddress'
                                    )}
                                </Title>
                                {surgeryDetails?.accountId === undefined ||
                                surgeryDetails.accountId === '' ? (
                                    <>
                                        <AlertMsg>
                                            {t(
                                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.alertMsg'
                                            )}
                                        </AlertMsg>
                                    </>
                                ) : billToShipToPartnerRole == 'BILL_TO' &&
                                  (surgeryDetails.billToId === '' ||
                                      surgeryDetails.billToId === undefined) ? (
                                    <>
                                        <AlertMsg>
                                            {t(
                                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.alertMsg1'
                                            )}
                                        </AlertMsg>
                                    </>
                                ) : (
                                    <>
                                        {!isCondensedView ? (
                                            <CarousalContainer
                                                height={
                                                    window.innerWidth <=
                                                        sizes.mobileDevice ||
                                                    isIpad()
                                                        ? '195px'
                                                        : '173px'
                                                }
                                                overflowX={
                                                    window.innerWidth <=
                                                        sizes.smalDevice ||
                                                    isIpad()
                                                        ? 'hidden'
                                                        : 'clip'
                                                }
                                            >
                                                <Carousel
                                                    normalizeInvalidPosition={true}
                                                    setBottom={
                                                        window.innerWidth >=
                                                        sizes.smalDevice
                                                            ? '-35px'
                                                            : (window.innerWidth <=
                                                                  sizes.smalDevice ||
                                                                  isIpad()) &&
                                                              '-25%'
                                                    }
                                                    carouselPosition={
                                                        selectedCard
                                                    }
                                                    mobileBottom={'0px'}
                                                >
                                                    {nonTissueAddress !==
                                                        undefined &&
                                                    nonTissueAddress.length !==
                                                        0
                                                        ? nonTissueAddress.map(
                                                              (item, id) => {
                                                                  return (
                                                                      <ShipToCorousalDiv
                                                                      id={`reportUsage-replen-selectShipToAddressOutside-shipToCorousalDiv-${id}`}
                                                                          onClick={() => {
                                                                            try {
                                                                              handleShippingToCardClick(
                                                                                  item,
                                                                                  id
                                                                              );
                                                                              } catch (error) {
                                                                                  logErrorToConsole(error);
                                                                             }
                                                                          }}
                                                                          key={
                                                                              'item' +
                                                                              id
                                                                          }
                                                                      >
                                                                          <ShippingAddressCard
                                                                              width={
                                                                                  '98%'
                                                                              }
                                                                              height={
                                                                                  '164px'
                                                                              }
                                                                              boxShadow={
                                                                                  '0px 0px 6px #00000029'
                                                                              }
                                                                              address={
                                                                                  item
                                                                              }
                                                                              isMobileDevice={
                                                                                  true
                                                                              }
                                                                              showBorder={
                                                                                  selectedCard ===
                                                                                  id
                                                                                      ? true
                                                                                      : false
                                                                              }
                                                                          />
                                                                      </ShipToCorousalDiv>
                                                                  );
                                                              }
                                                          )
                                                        : null}
                                                </Carousel>
                                            </CarousalContainer>
                                        ) : (
                                            <>
                                               
                                                <AutoComplete
                                                    customWidth={'46%'}
                                                    inputRef={shipToRef}
                                                    showScrollBar={true}
                                                    disableClearable={false}
                                                    isFullWidth={true} 
                                                    boxShadow={'0px 3px 6px #00000029'}
                                                    options={ nonTissueAddress &&
                                                        nonTissueAddress?.length >
                                                            0
                                                            ? nonTissueAddress
                                                            : []}
                                                    value={shipToInputValue}
                                                    inputValue={
                                                        selectedAccount ===
                                                        ''
                                                            ? ''
                                                            : shipToInputValue?.formattedShippingAddressId
                                                            ? shipToInputValue?.formattedShippingAddressId
                                                            : shipToInputValue?.searchValue
                                                            ? shipToInputValue?.searchValue
                                                            : ''
                                                    }
                                                    clearOnBlur={false}
                                                    itemTemplate={(option) =>  ShipToOptionTemplate(
                                                        option
                                                    )}
                                                    onChange={(value, reason) => { 
                                                        if (
                                                            reason ===
                                                                'clear' ) {
                                                            setshipToInputValue(
                                                                emptyAddressObj
                                                            );
                                                            handleShipToAddress(
                                                                'handleInputChange',
                                                                '',
                                                                '',
                                                                reason
                                                            ); 
                                                        } else {
                                                            handleShipToAddress(
                                                                'handleInputChange',
                                                                '',
                                                                value
                                                                    ? value
                                                                    : '',
                                                                reason
                                                            );
                                                        }
                                                        if(value==='')  setOpenShipToAddressDropdown(
                                                            true
                                                        );
                                                    }}
                                                    hideNoOptionText={false}
                                                    placeholder={t(
                                                        'common.selectOrSearchShipTo'
                                                    )}
                                                    field="formattedShippingAddressId" 
                                                    optionValue="formattedShippingAddressId"
                                                    id={'reportUsage-replen-selectShipToOutside-shippingAddress'}
                                                    onInputChange={(event, value, reset) => 
                                                        {
                                                            if(value){
                                                                handleShipToAddress(
                                                                    'handleSearch',
                                                                    event,
                                                                    value,
                                                                    reset
                                                                );
                                                            }
                                                            else if(reset==='clear'){
                                                                handleShipToAddress(
                                                                    'handleSearch',
                                                                    '',
                                                                    '',
                                                                    reset
                                                                );
                                                            }
                                                        }     
                                                    }
                                                    loading={
                                                        shipToAddressLoading
                                                    }
                                                    noOptionsText={
                                                        !shipToAddressLoading &&
                                                        nonTissueAddress?.length ===
                                                            0
                                                            ? t(
                                                                    'calendar.filterResultsPanel.noOptionText'
                                                                )
                                                            : shipToAddressLoading &&
                                                                t(
                                                                    'common.loadingText'
                                                                )
                                                    }
                                                    onFocus={() => {
                                                        try {
                                                        setOpenShipToAddressDropdown(
                                                            true
                                                        );
                                                        const searchValue =
                                                            shipToInputValue?.searchValue ??
                                                            '';

                                                        if (
                                                            (!searchValue &&
                                                                !shipToInputValue?.formattedShippingAddressId &&
                                                                nonTissueAddress?.length <
                                                                    1) ||
                                                            nonTissueAddress.length ===
                                                                0
                                                        ) {
                                                            handleShipToAddress(
                                                                'handleOnFocus',
                                                                '',
                                                                '',
                                                                ''
                                                            );
                                                        }
                                                        } catch (error) {
                                                          logErrorToConsole(error);
                                                        }
                                                    }}
                                                    disabled={
                                                        selectedAccount ===
                                                        ''
                                                    }
                                                    onOpen={() => {
                                                        try {
                                                        if (
                                                            selectedAccount ===
                                                                '' ||
                                                            shipToInputValue?.formattedShippingAddressId
                                                        ) {
                                                            setOpenShipToAddressDropdown(
                                                                false
                                                            );
                                                        } else {
                                                            setOpenShipToAddressDropdown(
                                                                true
                                                            );
                                                        }
                                                         } catch (error) {
                                                          logErrorToConsole(error);
                                                        }
                                                    }}
                                                    onClose={() => {
                                                        try {
                                                            setOpenShipToAddressDropdown(
                                                                false
                                                            );
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                    open={
                                                       shipToInputValue?.formattedShippingAddressId? false:
                                                       openShipToAddressDropdown
                                                    }
                                                    readOnly={shipToInputValue?.formattedShippingAddressId}
                                                    detailsMargin
                                                    marginLeft={'1.5px'}
                                                    zIndex={'99999'}                                               />
                                            </>
                                        )}
                                        <MainContainer
                                            margin={
                                                window.innerWidth <=
                                                sizes.mobileDevice
                                                    ? '0px'
                                                    : '16px 0px 2px 0px'
                                            }
                                            padding={
                                                isCondensedView
                                                    ? '0px'
                                                    : '20px 15px'
                                            }
                                            boxShadow={
                                                isCondensedView
                                                    ? '0px'
                                                    : '0px 0px 6px #00000029'
                                            }
                                            borderRadius={
                                                isCondensedView ? '0px' : '6px'
                                            }
                                        >
                                            <ShippingContainer>
                                                {attnFieldVisibility ==
                                                    VISIBLE && (
                                                    <ShippingContainerSize>
                                                        <Title
                                                            showAstrisk={false}
                                                        >
                                                            {t(
                                                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.attn'
                                                            )}
                                                        </Title>
                                                        <InputBox
                                                            placeholder={t(
                                                                'common.attentionReceivingOptional'
                                                            )}
                                                            value={attnValue}
                                                            id={'reportUsage-replen-selectShipToAddress-selectShipToAddressOutside-attn'}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                const specialCharRegex = /[*$@<>!^]/;
                                                                if (specialCharRegex.test(value)) {
                                                                    setAttnErrorMsg('Special Characters(*$@<>!^) not allowed');
                                                                } else {
                                                                    setAttnErrorMsg('');
                                                                }
                                                                setAttnValue(value);
                                                            }}
                                                            maxLength={40}
                                                        />
                                                        {attnErrorMsg && (
                                                            <AlertMsg>
                                                                {attnErrorMsg}
                                                            </AlertMsg>
                                                        )}
                                                    </ShippingContainerSize>
                                                )}

                                                {careOfFieldVisibilityZLCR ===
                                                    'VISIBLE' && (
                                                    <ShippingContainerSize
                                                        flexBasis="46%"
                                                        marginBottom={'16px'}
                                                    >
                                                        <Title
                                                            showAstrisk={
                                                                careOfFieldMandatory ===
                                                                MANDATORY
                                                            }
                                                        >
                                                            {t(
                                                                'reportUsage.replen.selectShipToAddress.careOf'
                                                            )}
                                                        </Title>
                                                        {/* )} */}

                                                        <InputBox
                                                            isBorderColor={true}
                                                            placeholder={t(
                                                                'reportUsage.replen.selectShipToAddress.careOfPlaceholder'
                                                            )} //need to move to string file
                                                            value={careOfValue}
                                                            id={'reportUsage-replen-selectShipToAddress-selectShipToAddressOutside-careOf'}
                                                            onChange={(e) => {
                                                                setCareOfValue(
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                            maxLength={30}
                                                        />
                                                    </ShippingContainerSize>
                                                )}
                                                {usageReplenishmentSurgeryDateVisibility ===
                                                          VISIBLE && (
                                                          <ShippingContainerSize flexBasis="46%">
                                                              <MainContainerItems
                                                                  width={'100%'}
                                                                  isReplenish={
                                                                      true
                                                                  }
                                                                  setMarginBottom={
                                                                      '16px'
                                                                  }
                                                                  // setMarginTop={
                                                                  //     'replenish'
                                                                  // }
                                                                  setMarginleft={
                                                                      // window.innerWidth <=
                                                                      // sizes.mobileDevice ?
                                                                      '0px'
                                                                      // : '55%'
                                                                  }
                                                              >
                                                                  <Title
                                                                      showAstrisk={
                                                                          usageReplenishmentSurgeryDateMandatoryRule ===
                                                                          'YES'
                                                                              ? true
                                                                              : false
                                                                      }
                                                                  >
                                                                      {t(
                                                                          'common.surgeryDateLabel'
                                                                      )}
                                                                  </Title>
                                                                  <SurgeryDateView>
                                                                      <DatePicker
                                                                          onChange={(
                                                                              value
                                                                          ) => {
                                                                              handleSurgeryDate(
                                                                                  value,
                                                                                  true
                                                                              );
                                                                          }}
                                                                          selectedDateFromDatePicker={
                                                                              surgeryDate
                                                                          }
                                                                          enableMinDate={
                                                                              false
                                                                          }
                                                                          minDate={
                                                                              new Date(
                                                                                  // excludesWeekendsForSurgeryDate()
                                                                                  //
                                                                                  new Date()
                                                                              )
                                                                          }
                                                                          // // minDate={
                                                                          //     new Date(
                                                                          //         moment().subtract(3, 'd')
                                                                          //     )
                                                                          // }
                                                                          // icon={Calendar}
                                                                          datePickerCalendarIcon={
                                                                              Calendar
                                                                          }
                                                                          placeholder={t(
                                                                              'common.surgeryDateLabel'
                                                                          )}
                                                                          datePickerBgColor="unset"
                                                                          datePickerDivWidth={
                                                                              '100%'
                                                                          }
                                                                          // sameDayRdd={
                                                                          //     currentDateDelivery ===
                                                                          //         'VISIBLE' &&
                                                                          //     new Date(
                                                                          //         requestDeliveryDate
                                                                          //     ).setHours(0, 0, 0, 0) ===
                                                                          //         new Date().setHours(
                                                                          //             0,
                                                                          //             0,
                                                                          //             0,
                                                                          //             0
                                                                          //         )
                                                                          //         ? true
                                                                          //         : false
                                                                          // }
                                                                          datePickerDivHeight="40px"
                                                                          fontSize="16px"
                                                                          left="10px"
                                                                          iconHeight="40px"
                                                                          datePopOverZIndex="100000"
                                                                          mbWidth={
                                                                              '100%'
                                                                          }
                                                                          smbWidth={
                                                                              '142px'
                                                                          }
                                                                          smbIconPaddingTop={
                                                                              '0px'
                                                                          }
                                                                          smbIconheight={
                                                                              '40px'
                                                                          }
                                                                          datePickerDivMbWidth={
                                                                              '100%'
                                                                          }
                                                                          datePickerDivMbHeight={
                                                                              '40px'
                                                                          }
                                                                          iconRight={
                                                                              '0px'
                                                                          }
                                                                          iconPaddingTop="7px"
                                                                          borderRadius="4px"
                                                                      />

                                                                      {/* <p> { : } {timeZone}</p> */}
                                                                  </SurgeryDateView>
                                                              </MainContainerItems>
                                                          </ShippingContainerSize>
                                                )}
                                                {requestedDeliveryDateVisibility ===
                                                    VISIBLE && (
                                                    <ShippingContainerSize flexBasis="46%"> 
                                                        <MainContainerItems
                                                            width={'100%'}
                                                            isReplenish={true}
                                                            setMarginBottom={
                                                                '16px'
                                                            }
                                                            // setMarginTop={
                                                            //     'replenish'
                                                            // }
                                                            setMarginleft={
                                                                // window.innerWidth <=
                                                                // sizes.mobileDevice ?
                                                                '0px'
                                                                // : '55%'
                                                            }
                                                        >
                                                            <Title
                                                                showAstrisk={
                                                                    requestedDeliveryDateMandatory ===
                                                                        'YES' ||
                                                                    requestedDeliveryDateMandatory ===
                                                                        'yes'
                                                                        ? true
                                                                        : false
                                                                }
                                                            >
                                                                {t(
                                                                    'common.requestedDeliveryDateLabel'
                                                                )}
                                                            </Title>
                                                            <RequestDeliveryDateView>
                                                                <DatePicker
                                                                    onChange={(
                                                                        value
                                                                    ) => {
                                                                        handleRequestDeliveryDate(
                                                                            value,
                                                                            true,
                                                                            '',
                                                                            true
                                                                        );
                                                                    }}
                                                                    rdd={true}
                                                                    disabled={
                                                                        selectedAccount ===
                                                                            '' ||
                                                                        selectedAccount ===
                                                                            undefined
                                                                            ? true
                                                                            : usageReplenishmentSurgeryDateVisibility ===
                                                                                  VISIBLE &&
                                                                              surgeryDate
                                                                            ? new Date(
                                                                                  surgeryDate
                                                                              ).setHours(
                                                                                  0,
                                                                                  0,
                                                                                  0,
                                                                                  0
                                                                              ) ===
                                                                              new Date().setHours(
                                                                                  0,
                                                                                  0,
                                                                                  0,
                                                                                  0
                                                                              )
                                                                                ? getDisable()
                                                                                    ? false
                                                                                    : true
                                                                                : getDisable()
                                                                                ? false
                                                                                : true
                                                                            : usageReplenishmentSurgeryDateVisibility !==
                                                                              VISIBLE
                                                                            ? false
                                                                            : true
                                                                    }
                                                                    selectedDateFromDatePicker={
                                                                        RequestDeliveryDate
                                                                    }
                                                                    minDate={
                                                                        requestedDeliveryDateCutOffTime
                                                                            ? new Date(
                                                                                  japanMinimunDate[0]
                                                                              )
                                                                            : getTomorrowDate()
                                                                    }
                                                                    enableMinDate={
                                                                        requestedDeliveryDateCutOffTime
                                                                            ? getDisabledDatesBasedOnJapanTime(
                                                                                  new Date(),
                                                                                  false,
                                                                                  requestedDeliveryDateCutOffTime,
                                                                                  surgeryDetails?.accountId
                                                                              )
                                                                            : [
                                                                                  new Date(),
                                                                              ]
                                                                    }
                                                                    maxDate={
                                                                        nextDay
                                                                            ? getTomorrowDate(
                                                                                  [],
                                                                                  enableRequestedDeliveryDateForWeekEnd !==
                                                                                      VISIBLE &&
                                                                                      true
                                                                              )
                                                                            : getNumberOfDaysBetweenTwoDates(
                                                                                  new Date(),
                                                                                  new Date(
                                                                                      surgeryDate
                                                                                  )
                                                                              ) <
                                                                                  4 &&
                                                                              new Date(
                                                                                  surgeryDate
                                                                              ).getDay() ===
                                                                                  1 &&
                                                                              countryISOCode !==
                                                                                  COUNTRY_CODE_JAPN
                                                                            ? new Date(
                                                                                  surgeryDate
                                                                              )
                                                                            : currentDateDelivery ===
                                                                                  VISIBLE &&
                                                                              new Date(
                                                                                  surgeryDate
                                                                              ).setHours(
                                                                                  0,
                                                                                  0,
                                                                                  0,
                                                                                  0
                                                                              ) ===
                                                                                  new Date().setHours(
                                                                                      0,
                                                                                      0,
                                                                                      0,
                                                                                      0
                                                                                  )
                                                                            ? new Date()
                                                                            : allDayRequestedDeliveryDate ===
                                                                              VISIBLE
                                                                            ? new Date(
                                                                                  surgeryDate
                                                                              )
                                                                            : moment(
                                                                                  new Date(
                                                                                      surgeryDate
                                                                                  )
                                                                              )
                                                                                  .startOf(
                                                                                      'day'
                                                                                  )
                                                                                  .subtract(
                                                                                      1,
                                                                                      'days'
                                                                                  )
                                                                                  .toDate()
                                                                    }
                                                                    disableWeekEnds={
                                                                        requestedDeliveryDateVisibility ===
                                                                            VISIBLE &&
                                                                        enableRequestedDeliveryDateForWeekEnd ===
                                                                            VISIBLE
                                                                            ? ''
                                                                            : [
                                                                                  0,
                                                                                  6,
                                                                              ]
                                                                    }
                                                                    datePickerCalendarIcon={
                                                                        Calendar
                                                                    }
                                                                    placeholder={t(
                                                                        'common.requestDeliveryDateDatePlaceHplder'
                                                                    )}
                                                                    datePickerBgColor="unset"
                                                                    datePickerDivWidth="100%"
                                                                    datePickerDivHeight="40px"
                                                                    datePickerDivMbHeight="40px"
                                                                    borderRadius="4px"
                                                                    fontSize="16px"
                                                                    left="10px"
                                                                    iconHeight="40px"
                                                                    iconRight="0px"
                                                                    iconPaddingTop="7px"
                                                                    datePopOverZIndex="100000"
                                                                    datePickerDivMbWidth={
                                                                        '100%'
                                                                    }
                                                                    smbWidth={
                                                                        '142px'
                                                                    }
                                                                    smbIconPaddingTop={
                                                                        '0px'
                                                                    }
                                                                    smbIconheight={
                                                                        '40px'
                                                                    }
                                                                />
                                                            </RequestDeliveryDateView>
                                                        </MainContainerItems> 
                                                    </ShippingContainerSize>
                                                )}

                                                {surgeryNumberUsageReplenishmentVisibility ===
                                                    VISIBLE && (
                                                    <ShippingContainerSize flexBasis="46%"> 
                                                        <MainContainerItems
                                                            width={'100%'}
                                                            isReplenish={true}
                                                            setMarginBottom={
                                                                '16px'
                                                            }
                                                            // setMarginTop={
                                                            //     'replenish'
                                                            // }
                                                            setMarginleft={
                                                                // window.innerWidth <=
                                                                // sizes.mobileDevice ?
                                                                '0px'
                                                                // : '55%'
                                                            }
                                                        >
                                                            <Title
                                                                showAstrisk={
                                                                    surgeryNumberUsageReplenishmentMandatory ===
                                                                    'YES'
                                                                        ? true
                                                                        : false
                                                                }
                                                            >
                                                                {t(
                                                                    'common.surgeryNumberLabel'
                                                                )}
                                                            </Title>

                                                            <Select
                                                                id="reportUsage-selectShipToAddressOutside-selectShipToAddress-selectShippingMethod"
                                                                value={
                                                                    numberOfSurgery
                                                                }
                                                                options={
                                                                    DropdownOption()
                                                                        .numberOfSurgery
                                                                }
                                                                onChange={(
                                                                    count
                                                                ) => {
                                                                    setNumberOfSurgery(
                                                                        count
                                                                    );
                                                                }}
                                                                width={'100%'}
                                                                smWidth="100%"
                                                                xSmWidth="40%"
                                                                defaultValue={
                                                                    numberOfSurgery
                                                                }
                                                            />
                                                        </MainContainerItems>
                                                        {' '}
                                                    </ShippingContainerSize>
                                                )}

                                                <ShippingContainerSize flexBasis="46%">
                                                    <Title
                                                        showAstrisk={true}
                                                        display={'flex'}
                                                    >
                                                        {t(
                                                            'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.shippingMethod'
                                                        )}
                                                        <Title
                                                            marginBottom={true}
                                                            color={'#ED002A'}
                                                        >
                                                            {`\u00A0${t(
                                                                'common.shippingMethodImportantMsg'
                                                            )}`}
                                                        </Title>
                                                    </Title>
                                                    <Select
                                                                id="reportUsage-selectShipToAddressOutside-selectShipToAddress-shippingMethodImportantMsg"
                                                        borderRadius="4px"
                                                        value={
                                                            countryISOCode ===
                                                                COUNTRY_CODE_JAPN &&
                                                            requestedDeliveryDateVisibility ===
                                                                VISIBLE &&
                                                            requestedDeliveryDateMandatory ===
                                                                'YES' &&
                                                            RequestDeliveryDate
                                                                ? shippingMethodValue
                                                                : countryISOCode ===
                                                                      COUNTRY_CODE_JAPN &&
                                                                  requestedDeliveryDateVisibility ===
                                                                      VISIBLE &&
                                                                  requestedDeliveryDateMandatory ===
                                                                      'NO'
                                                                ? shippingMethodValue
                                                                : requestedDeliveryDateVisibility !==
                                                                      VISIBLE ||
                                                                  countryISOCode !==
                                                                      COUNTRY_CODE_JAPN
                                                                ? shippingMethodValue
                                                                : ''
                                                        }
                                                        options={
                                                            countryISOCode ===
                                                                COUNTRY_CODE_JAPN &&
                                                            !showShippingMethod &&
                                                            selectedAccount
                                                                ? requestedDeliveryDateVisibility ===
                                                                      VISIBLE &&
                                                                  (requestedDeliveryDateMandatory ===
                                                                      'YES' ||
                                                                      requestedDeliveryDateMandatory ===
                                                                          'NO') &&
                                                                  RequestDeliveryDate
                                                                    ? shippingMethod
                                                                    : requestedDeliveryDateVisibility !==
                                                                      VISIBLE
                                                                    ? shippingMethod
                                                                    : !RequestDeliveryDate &&
                                                                      requestedDeliveryDateVisibility ===
                                                                          VISIBLE &&
                                                                      requestedDeliveryDateMandatory ===
                                                                          'YES'
                                                                    ? ''
                                                                    : shippingMethod
                                                                : requestedDeliveryDateMandatory ===
                                                                      'YES' &&
                                                                  countryISOCode !==
                                                                      US_COUNTRY_CODE &&
                                                                  showShippingMethod
                                                                ? ''
                                                                : shippingMethod
                                                        }
                                                        placeholder={t(
                                                            'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.selectShippingMethod'
                                                        )}
                                                        optionLabel="shippingMethodName"
                                                        onChange={
                                                            setShippingMethodValue
                                                        }
                                                        disabled={
                                                            countryISOCode !==
                                                            COUNTRY_CODE_JAPN
                                                                ? selectedShipTo ===
                                                                  ''
                                                                : false
                                                        }
                                                    />
                                                </ShippingContainerSize>
                                               { transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId)  && (
                                                          <ShippingContainerSize flexBasis="46%">
                                                              <Title
                                                                  display={
                                                                      'flex'
                                                                  }
                                                              >
                                                                  {t(
                                                                      'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                                  )}
                                                                  <Title
                                                                      marginBottom={
                                                                          true
                                                                      }
                                                                      color={
                                                                          '#ED002A'
                                                                      }
                                                                      showAstrisk={transferRecipientMandatory === MANDATORY}
                                                                  >{`\u00A0${t(
                                                                      'common.transferRecipientImportantMsg'
                                                                  )}`}</Title>
                                                              </Title>
                                                              
                                                              <AutoComplete
                                                                inputRef={transferRecipientRef}
                                                                showScrollBar={true}
                                                                disableClearable={false}
                                                                isFullWidth={true} 
                                                                boxShadow={'0px 3px 6px #00000029'}
                                                                options={transferRecipient &&
                                                                    transferRecipient?.length >
                                                                        0
                                                                        ? transferRecipient
                                                                        : []}
                                                                value={ transferRecipientSelectedValue?? ''}
                                                                inputValue={  selectedAccount !==
                                                                    ''
                                                                        ? transferRecipientValue?.accountName
                                                                        ? transferRecipientValue?.accountName
                                                                        : transferRecipientSelectedValue 
                                                                        : ''}
                                                                clearOnBlur={false}
                                                                itemTemplate={(
                                                                    option
                                                                ) =>
                                                                    OptionTransferRecipient(
                                                                        option
                                                                    )
                                                                }
                                                                onChange={(value, reason) => { 
                                                                    if (reason==='clear') {
                                                                        handleTransferRecipient(
                                                                            'handleInputChange',
                                                                            '',
                                                                            '',
                                                                            true
                                                                        );
                                                                    }
                                                                    handleTransferRecipient(
                                                                        'handleInputChange',
                                                                        '',
                                                                        value
                                                                            ? value
                                                                            : '',
                                                                        reason
                                                                    );
                                                                    if(value==='')  setOpenTransferRecipientDropdown(true);
                                                                }}
                                                                hideNoOptionText={false}
                                                                placeholder={t(
                                                                    'reportUsage.replen.selectShipToAddress.transferRecipientPlaceholder'
                                                                )}
                                                                field="accountName" 
                                                                optionValue="accountName"
                                                                id={'reportUsage-replen-selectShipToOutside-transferRecipient'}
                                                                onInputChange={(event, value, reset) => 
                                                                    {
                                                                        if(value){
                                                                            value?.length !==
                                                                            11
                                                                                ? handleTransferRecipient(
                                                                                    'handleSearch',
                                                                                    event,
                                                                                    value
                                                                                        ? value
                                                                                        : '',
                                                                                    reset
                                                                                )
                                                                                : () => {};
                                                                        }
                                                                        else if(reset==='clear'){ 
                                                                            handleTransferRecipient(
                                                                                    'handleSearch',
                                                                                    '',
                                                                                    '',
                                                                                    reset
                                                                                );
                                                                        }
                                                                    }     
                                                                }
                                                                loading={
                                                                    transferRecipientLoading
                                                                }
                                                                noOptionsText={
                                                                    !transferRecipientLoading &&
                                                                    transferRecipient?.length ===
                                                                        0
                                                                        ? t(
                                                                            'calendar.filterResultsPanel.noOptionText'
                                                                        )
                                                                        : transferRecipientLoading &&
                                                                        t(
                                                                            'common.loadingText'
                                                                        )
                                                                }
                                                                onFocus={(
                                                                    event
                                                                ) =>
                                                                    handleTransferRecipient(
                                                                        'handleOnFocus',
                                                                        event
                                                                    )
                                                                }
                                                                disabled={
                                                                    selectedAccount ===
                                                                    ''
                                                                }
                                                                onOpen={() => {
                                                                    try {
                                                                        if (
                                                                            selectedAccount ===
                                                                            ''
                                                                        ) {
                                                                            setOpenTransferRecipientDropdown(
                                                                                false
                                                                            );
                                                                        } else {
                                                                            setOpenTransferRecipientDropdown(
                                                                                true
                                                                            );
                                                                        }
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                                onClose={() => {
                                                                    try {
                                                                        setOpenTransferRecipientDropdown(
                                                                            false
                                                                        );
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                                open={
                                                                    transferRecipientValue?.accountName? false:openTransferRecipientDropdown
                                                                }
                                                                readOnly={transferRecipientValue?.accountName}
                                                                detailsMargin
                                                                marginLeft={'1.5px'}
                                                                zIndex={'99999'}
                                                            />
                                                          </ShippingContainerSize>
                                                      )}
                                            </ShippingContainer>
                                        </MainContainer>
                                    </>
                                )}
                            </>
                        )}
                    </CollapsableCard>
                </>
            )}
            <CommonEmptyBox mobileMargin={'40%'} />
            {!advanceSearchValue && territory == OutsideTerritory() ? (
                <BottomNavigation
                    justifyContent={'flex-end'}
                    opacity={'1'}
                    position={'absolute'}
                    mbPosition={'fixed'}
                    isIPadPotrait={true}
                    iPadPortraitFooterPosition={'absolute'}
                    padding={'5px'}
                    right={'0'}
                >
                    <AdvanceSelectButton>
                        <Button
                            id={'reportUsage-replen-shipToOutsideAddressButton'}
                            show={true}
                            // primary={enableAddressButton}
                            variant={enableAddressButton ? ButtonStyles?.primary : ButtonStyles?.disabled}
                            disabled={!enableAddressButton}
                            height={'38px'}
                            clicked={() => {
                                try {
                                setShipToClick(true);
                                setApplyClickOutside(true);
                                applyShippingAddress();
                                onClose();
                                 } catch (error) {
                                   logErrorToConsole(error);
                                 }
                            }}
                            margin={'5px'}
                            // fontSize={'15px'}
                            width={window.innerWidth <= 576 ? '332px' : '244px'}
                        >
                            {t(
                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.applyShipToAddress'
                            )}
                        </Button>
                    </AdvanceSelectButton>
                </BottomNavigation>
            ) : null}
        </>
    );
};

export default ShipAddressModalOutside;
